<template>
  <v-container>
    <WorkflowsPanels
      type="payment"
      :workflows="contract.workflows"
      @update-workflows="$emit('update-workflows')"
    />
  </v-container>
</template>

<script>
import { DEFAULT_CONTRACT } from '@/helpers'

export default {
  name: 'WorkflowsTab',
  props: {
    contract: {
      type: Object,
      default: () => DEFAULT_CONTRACT
    }
  },
  data () {
    return { }
  }
}
</script>
